import Hint from "@common/controls/Hint/component";
import { type OptionItem } from "@common/controls/Inputs/Select/component";
import { useI18n } from "@common/hooks/i18n";
import { sort } from "@common/lib/array";
import { i18nFormat } from "@common/lib/i18n";
import React from "react";

export interface OptionsWithShowMoreProps {
  data: OptionItem<number | string | boolean>[];
}

const OptionsWithShowMore = (props: OptionsWithShowMoreProps) => {
  const i18n = useI18n();

  if (!props.data.length) return null;
  if (props.data.length === 1) return <span>{props.data[0].label}</span>;

  const sorted = sort(props.data, { key: "label" });
  return (
    <span>
      {sorted[0].label}{" "}
      <Hint
        hint={i18nFormat(i18n.andNMore, ["N", props.data.length - 1]).toLowerCase()}
        tooltip={sorted
          .slice(1)
          .map((x) => x.label)
          .join(", ")}
      />
    </span>
  );
};

export default OptionsWithShowMore;
